import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';

const CookiesWidget = (props) => {
    const { t } = useTranslation()

    if(!props?.title && !props?.descriptions && !props?.text && !props?.items) return null

    return (
        <div data-test-id="cookies-wr" className={"widget widget-cookies" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                <div className="col-12">
                    {props?.title ? <h3 data-test-id="cookies-title" className={(props?.dark ? "text-white " : "") + "mb-4"}>{props.title}</h3> : null}
                    {props?.descriptions ? <p data-test-id="cookies-ver" className={(props?.dark ? "text-white " : "") + "mb-4 text-medium text-sm-small"}>{props.descriptions}</p> : null}
                    {props?.text ? <div data-test-id="cookies-description" className={"editor mb-4" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }}></div> : null}
                </div>
                <div className="col-12">
                    {
                        props?.items ?
                            props.items.map((cookies, index) => {
                                return (
                                    <div key={'t_' + index}>
                                        {
                                            cookies?.accordion ?
                                                <>
                                                    <Collapse
                                                        data-test-id={"cookies-el-collapse-" + index}
                                                        defaultActiveKey={['0']}
                                                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                                                        items={[
                                                            {
                                                                key: '1',
                                                                label: <div data-test-id={"cookies-el-title-" + index} className={(props?.dark ? "text-white " : "") + "text-bold"}>{cookies.head}</div>,
                                                                children: <div data-test-id={"cookies-el-text-" + index} className="editor" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cookies.text) }}></div>,
                                                            },
                                                        ]}
                                                        className={(cookies?.cookies_preferences ? "" : "mb-4 ") + 'text-white' + (props?.dark ? " bg-dark" : "")}
                                                    />
                                                    {
                                                        cookies?.cookies_preferences ?
                                                            <button
                                                                data-test-id={"cookies-el-btn-" + index}
                                                                type="button"
                                                                onClick={() => {
                                                                    const event = new Event('openCookiesPopup');
                                                                    document.dispatchEvent(event)
                                                                }}
                                                                className={"btn-cookies h-32 px-12 text-semibold mt-3 mb-4" + (props?.dark ? " bg-dark" : "")}
                                                            >
                                                                {t('buttons.Cookies preference')}
                                                            </button>
                                                            : null
                                                    }
                                                </>
                                                :
                                                <div className="mb-4">
                                                    {cookies?.head ? <p className={(props?.dark ? "text-white " : "") + "text text-bold mb-1"}>{cookies.head}</p> : null}
                                                    {cookies?.text ? <div className={"editor" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(cookies.text)}}></div> : null}
                                                    {
                                                        cookies?.cookies_preferences ?
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    const event = new Event('openCookiesPopup');
                                                                    document.dispatchEvent(event)
                                                                }}
                                                                className={"btn-cookies h-32 px-12 text-semibold mt-3" + (props?.dark ? " bg-dark" : "")}
                                                            >
                                                                {t('buttons.Cookies preference')}
                                                            </button>
                                                            : null
                                                    }
                                                </div>
                                        }
                                    </div>
                                )
                            }) : null
                    }
                </div>
            </div>
        </div>
    )
}

CookiesWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    items: PropTypes.array,
    className: PropTypes.string,
}

export default CookiesWidget;
